module.exports = __webpack_public_path__ + "img/partnerships-for-the-goals.872af437.png";